const themeContract = {
  tu: {
    container: {
      borderRadius: 'radius'
    },
    bodyCopy: {
      color: 'darker',
      backgroundColor: 'white'
    },
    heading: {
      color: 'brand-1'
    }
  },
  argos: {
    container: {
      borderRadius: ''
    },
    bodyCopy: {
      color: 'darker',
      backgroundColor: 'lighter'
    },
    heading: {
      color: 'grey-90'
    }
  },
  habitat: {
    container: {
      borderRadius: 'radius'
    },
    bodyCopy: {
      color: 'darker',
      backgroundColor: 'lighter'
    },
    heading: {
      color: 'grey-90'
    }
  },
  nectar: {
    container: {
      borderRadius: 'radius'
    },
    bodyCopy: {
      color: 'darker',
      backgroundColor: 'white'
    },
    heading: {
      color: 'purple-90'
    }
  },
  sainsburys: {
    container: {
      borderRadius: 'radius'
    },
    bodyCopy: {
      color: 'darker',
      backgroundColor: 'white'
    },
    heading: {
      color: 'grey-80'
    }
  }
}

export { themeContract }
